"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
const Inner_1 = require("./Inner");
exports.EmailCanvasPreviewView = () => {
    const { state: { draftEmail: { html }, }, } = hooks_1.useEmailCanvasContext();
    return react_1.default.createElement(Inner_1.EmailCanvasPreviewViewInner, { html: html });
};
//# sourceMappingURL=index.js.map